import { render, staticRenderFns } from "./iconOnOff.vue?vue&type=template&id=446b55dc&"
import script from "./iconOnOff.vue?vue&type=script&lang=js&"
export * from "./iconOnOff.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports